exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".hidden {\n    visibility: hidden;\n}\n\n.list-group-item {\n    color: black;\n    border: transparent;\n}\n\n.list-group-item span {\n    font-size: 1.4em;\n}\n\n.folder-icon {\n    color: #75798c;\n}\n\n.list-group-item:hover,\n.list-group-item.active:hover,\n.list-group-item:hover .folder-icon,\n.list-group-item.active:hover .folder-icon {\n    background-color: #5894d7;\n    color: white;\n}\n\n.list-group-item.active,\n.list-group-item.active .folder-icon {\n    background-color: #68b0ff;\n    color: white;\n}\n\n.list-group .list-group-item {\n    padding-left: 1.75rem;\n}\n\n.list-group > .list-group-item:first-child {\n    padding-left: 1.25rem;\n}\n\n.btn-back,\n.list-group-item .btn,\n.list-group-item .btn:focus,\n.list-group-item .btn:hover {\n    box-shadow: 0 0 0 0 transparent;\n    color: inherit;\n    text-decoration: none;\n    transition: all 0s ease-in-out;\n}\n\n.btn-back {\n    font-size: 1.4em;\n    padding: 0;\n}\n\n.btn-back:hover {\n    color: #9E9E9E;\n}\n\n.btn.current-parent,\n.btn.current-parent:hover {\n    background-color: transparent;\n    border-color: transparent;\n    color: #c2c2c2;\n    box-shadow: 0 0 0 0 transparent;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/folder/move-modal/move-modal.component.css
// module id = 746
// module chunks = 0